import { AppState } from '@chegg-wt/core/state/types'
import { PaperType } from '@chegg-wt/core/types/paraphraser'
import { SentenceOffset, ToastType, WAFeatures } from './types'

export const isParaphraseFlagEnabledSelector = (state: AppState): boolean =>
  state.paraphraser.paraphraseFlag

export const isPaperCheckInProgressSelector = (state: AppState): boolean =>
  state.paraphraser.isPaperCheckInProgress

export const feedbacksSelector = (state: AppState) => state.paraphraser.feedbackList

export const activeFeedbackTabSelector = (state: AppState) =>
  state.paraphraser.activeFeedbackTab

export const sentenceOffsetsSelector = (state: AppState) =>
  state.paraphraser.sentenceOffsets

export const activeFeedbackCardIdSelector = (state: AppState) =>
  state.paraphraser.activeFeedbackCardId

export const isTimedOutSelector = (state: AppState) => state.paraphraser.isTimedOut

export const totalFeedbackCountSelector = (state: AppState) =>
  state.paraphraser.totalFeedbackCount

export const rewritePanelSentencesSelector = (state: AppState): SentenceOffset[] =>
  state.paraphraser.rewritePanelSentences
export const quickActionPanelTypeSelector = (state: AppState) =>
  state.paraphraser.quickActionPanelType

export const paperIdSelector = (state: AppState) => state.paraphraser.paperId
export const paperTitleSelector = (state: AppState) => state.paraphraser.paperTitle
export const paperStatusSelector = (state: AppState) => state.paraphraser.paperStatus
export const paperRequiresRecheckSelector = (state: AppState) =>
  state.paraphraser.requiresReCheck

export const isTransferOfOwnershipInProgressSelector = (state: AppState) =>
  state.paraphraser.isTransferOfOwnershipInProgress

export const wordCountSelector = (state: AppState): number => state.paraphraser.wordCount

export const toastSelector = (state: AppState): ToastType => state.paraphraser.toastType

export const fetchNewSentencesLoadingSelector = (state: AppState): boolean =>
  state.paraphraser.fetchNewSentencesLoading

export const isWritingAssistantHomeFlagEnabledSelector = (state: AppState): boolean =>
  state.paraphraser.writingAssistantHomeFlag

export const enabledWAFeaturesSelector = (state: AppState): WAFeatures =>
  state.paraphraser.enabledWritingAssistantFeatures

export const isNewDocumentRequestedSelector = (state: AppState): boolean =>
  state.paraphraser.isNewDocumentRequested

export const undoEnabledSelector = (state: AppState): boolean =>
  state.paraphraser.undoEnabled

export const redoEnabledSelector = (state: AppState): boolean =>
  state.paraphraser.redoEnabled

export const paperListSelector = (state: AppState): PaperType[] =>
  state.paraphraser.paperList

export const isLoggingOutSelector = (state: AppState): boolean =>
  state.paraphraser.isLoggingOut
